var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRubleBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "#5a5f72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75991 13.88C14.2639 13.88 16.7279 11.544 16.7279 6.74402C16.7279 2.16802 13.7519 0.40802 9.20791 0.40802C6.80791 0.40802 4.66391 0.600019 2.93591 0.72802V11.032H0.503906V13.88H2.93591V16.44H0.503906V19.256H2.93591V23H6.39191V19.256H12.6319V16.44H6.39191V13.88H8.75991ZM8.91991 3.64002C12.3439 3.64002 13.1439 4.98402 13.1439 7.25602C13.1439 9.68802 11.8639 11.032 8.40791 11.032H6.39191V3.76802C7.12791 3.70402 7.95991 3.64002 8.91991 3.64002Z",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubleBold);
export default __webpack_public_path__ + "static/media/rubleBold.ede996e8.svg";
export { ForwardRef as ReactComponent };